import classNames from 'classnames';

import styles from './StatusBadge.module.css';

/**
 * Semantic status pill for the user search (Active / Inactive / Trial Expired /
 * Live). @revelio/ui's Badge has no green/success colour, and these are signal
 * not decoration, so this carries the semantic --ui-green/red/navy tokens
 * directly. `colorScheme` matches the values the search status helpers return.
 */
const COLOR_CLASS: Record<string, string> = {
  green: styles.green ?? '',
  red: styles.red ?? '',
  blue: styles.blue ?? '',
  gray: styles.gray ?? '',
};

interface StatusBadgeProps {
  colorScheme: string;
  children: string;
}

export function StatusBadge({ colorScheme, children }: StatusBadgeProps) {
  return (
    <span className={classNames(styles.badge, COLOR_CLASS[colorScheme])}>
      {children}
    </span>
  );
}
